<div class="overlay" (click)="closeModal()" (keyup)="closeModal()" (keydown)="closeModal()">
    <div class="profile-modal" (click)="$event.stopPropagation()" (keyup)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        <div class="profile-title">{{title}}</div>
        <div class="photo-container">
            <img [src]="imgSrc" alt="Profile" class="profile-photo" />
        </div>
        <button class="remove-btn" (click)="removePhoto()">Remove</button>
        <div class="divider"></div>
        <div class="action-buttons">
            <button class="close-btn" (click)="closeModal()">Close</button>
            <button class="change-btn" (click)="changePhoto()">Change</button>
        </div>
    </div>
</div>

